import React, { useState } from 'react'
import { Header, Image, Label, Icon, Grid, Modal, Button, Divider } from 'semantic-ui-react'
import { useTranslation } from "react-i18next";
import ShowMoreText from "react-show-more-text";

import "./AccommodationHost.css"


const AccommodationHost = () => {
    const { t } = useTranslation();
    const [open, setOpen] = useState(false)
    return (<div id="location-section">
        <Header as='h3'>
            <Image className="rounded-50" src='https://react.semantic-ui.com/images/avatar/small/stevie.jpg' />
            <Header.Content className="m-05">
                فرناز عبداللهی
                <Header.Subheader className="m-05">تاریخ عضویت: 1397/08/05</Header.Subheader>
            </Header.Content>
        </Header>
        <Grid columns={2} stackable>
            <Grid.Column>
                <Grid.Row>
                    <div className="d-flex flex-row align-items-center">
                        <Label basic className="border-none d-flex flex-row align-items-center ">
                            <Icon className="p-05-r p-05-l m-0 m-4px-b" name='star' color="red" />
                            <Header className="m-0" as='h4'> 1,458 {t("property:Reviews")}</Header>
                        </Label>

                        <Label basic className="border-none d-flex flex-row align-items-center ">
                            <Icon className="p-05-r p-05-l m-0 m-4px-b" name='check square' color="red" />
                            <Header className="m-0" as='h4'> {t("property:IdentityVerified")}</Header>
                        </Label>
                    </div>
                    <ShowMoreText
                        lines={2}
                        more={t("property:More")}
                        less={t("property:Less")}
                        className="content-css m-1"
                        anchorClass="my-anchor-css-class ui button bg-transparent text-blue"
                        expanded={false}
                        truncatedEndingComponent={""}
                    >

                        لورم ایپسوم متن ساختگی با تولید سادگی نامفهوم از صنعت چاپ و با استفاده از طراحان گرافیک است. چاپگرها و متون بلکه روزنامه و مجله در ستون و سطرآنچنان که لازم است و برای شرایط فعلی تکنولوژی مورد نیاز و کاربردهای متنوع با هدف بهبود ابزارهای کاربردی می باشد. کتابهای زیادی در شصت و سه درصد گذشته، حال و آینده شناخت فراوان جامعه و متخصصان را می طلبد تا با نرم افزارها شناخت بیشتری را برای طراحان رایانه ای علی الخصوص طراحان خلاقی و فرهنگ پیشرو در زبان فارسی ایجاد کرد. در این صورت می توان امید داشت که تمام و دشواری موجود در ارائه راهکارها و شرایط سخت تایپ به پایان رسد وزمان مورد نیاز شامل حروفچینی دستاوردهای اصلی و جوابگوی سوالات پیوسته اهل دنیای موجود طراحی اساسا مورد استفاده قرار گیرد.
                    </ShowMoreText>
                </Grid.Row>
            </Grid.Column>
            <Grid.Column>
                <Label basic className="border-none d-flex flex-row align-items-center ">
                    <Header className="m-0" as='h4'>{t("property:ResponseRate")} :</Header>
                    <p className="m-05" >بیش از ۲ ساعت</p>
                </Label>

                <Label basic className="border-none d-flex flex-row align-items-center ">
                    <Header className="m-0" as='h4'> {t("property:ResponseTime")} : </Header>
                    <p className="m-05" >99 درصد</p>
                </Label>

                <Button color="blue" basic className="m-05">{t("property:ViewHostProfile")} </Button>
            </Grid.Column>
        </Grid>

    </div>
    )
}
export default AccommodationHost